export const ADMIN_BASE_PATH = "/cjp0t0sa6m1n";
export const ADMIN_LOGIN_PATH = ADMIN_BASE_PATH;
export const ADMIN_DASHBOARD_PATH = `${ADMIN_BASE_PATH}/dashboard`;
export const ADMIN_HOME_HERO_PHOTOS_PATH = `${ADMIN_DASHBOARD_PATH}/home-page-photo-show`;
export const ADMIN_LATEST_PHOTOS_PATH = `${ADMIN_DASHBOARD_PATH}/latest-photographs`;
export const ADMIN_VIDEOS_PATH = `${ADMIN_DASHBOARD_PATH}/videos`;
export const ADMIN_NEWSLETTER_SUBSCRIBERS_PATH = `${ADMIN_DASHBOARD_PATH}/newsletter-subscribers`;
export const ADMIN_ABOUT_SELFIES_PATH = `${ADMIN_DASHBOARD_PATH}/about-selfies`;

export const adminHomeHeroPhotoEditPath = (id) =>
  `${ADMIN_HOME_HERO_PHOTOS_PATH}/${id}/edit`;
